module.exports = __webpack_public_path__ + "static/media/complexPic3.8fea64d3.png";